'use client';

import { EntityRatingCommentCount, Professional, ProfessionalSchedule } from '@medprev-web-app/api-graphql-client';

import {
  getProfessionalProfileFromSearchApi,
  ProfessionalProfileFromSearchApi,
} from '@/app/(main)/(pages)/(institucional)/(index)/profissionais/_services/get-professional-profile-from-search-api.service';
import {
  EntityProfileStatus,
  useEntityProfile,
  UseEntityProfileReturn,
} from '@/app/(main)/(pages)/_components/entities/hooks/use-entity-profile.hook';
import { RatingComment } from '@/types';

export type ProfessionalProfileStatus = EntityProfileStatus;

export interface ProfessionalProfileFromBff {
  professional: Professional;
  commentsCount?: EntityRatingCommentCount | null;
  inPersonData: ProfessionalSchedule[];
  telehealthData: ProfessionalSchedule[];
  initialComments?: RatingComment[];
}

export type UseProfessionalProfileReturn = UseEntityProfileReturn<ProfessionalProfileFromSearchApi>;

function fromBff(bff: ProfessionalProfileFromBff): ProfessionalProfileFromSearchApi {
  return {
    professional: bff.professional,
    gender: null,
    commentsCount: bff.commentsCount ?? { total: 0, comments: [] },
    initialComments: bff.initialComments ?? [],
    hasMoreComments: false,
    inPersonSchedules: bff.inPersonData,
    hasTelehealth: bff.telehealthData.length > 0,
  };
}

export function useProfessionalProfile(
  slug: string,
  bff: ProfessionalProfileFromBff,
): UseProfessionalProfileReturn {
  return useEntityProfile(slug, {
    fetchProfile: getProfessionalProfileFromSearchApi,
    fallbackProfile: () => fromBff(bff),
    loggerContext: 'professional.profile-view',
  });
}
